import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M12.1895 20L7.18945 15H3.18945V9H7.18945L12.1895 4V20ZM14.1895 7.96973C15.6695 8.70973 16.6895 10.23 16.6895 12C16.6895 12.3051 16.6564 12.6022 16.5986 12.8896C16.151 13.3001 15.8543 13.8712 15.7979 14.5098L15.791 14.6904C15.3701 15.2496 14.8225 15.7072 14.1895 16.0195V7.96973ZM14.1895 3.23047C18.1994 4.14051 21.1895 7.72004 21.1895 12C21.1895 12.9298 21.0481 13.8264 20.7861 14.6699L20.7715 14.4443C20.6631 13.5013 20.031 12.7208 19.1768 12.3955C19.1841 12.2646 19.1895 12.1328 19.1895 12C19.1895 8.83001 17.0794 6.15004 14.1895 5.29004V3.23047Z" />
    <path
      d="M18.288 14.7328L18.3601 20.2057M14.8345 18.4379L18.37 21.9734M18.3601 21.9634L21.8956 18.4278"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </>,
  'AudioDownload',
)
